module.exports = __webpack_public_path__ + "static/media/ex-landing.dd36f8de.jpg";